import React from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";
import "./FieldUpdateModal.css";
import { IoCheckmark, IoClose } from "react-icons/io5";

const FieldUpdateModal = ({ show, onHide, taskData, fileData }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" className="task-modal" dialogClassName="custom-modal-width">
      <Modal.Body>

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
              <div className="d-flex align-items-center gap-3">
                    <h5 className="fw-bold">TSK-001</h5>
                    {/* TAGS */}
                    <div className="d-flex gap-2">
                        <span className="badge bg-danger">HIGH</span>
                        <span className="badge bg-primary">OPEN</span>
                    </div>
              </div>
                <small className="text-muted">Case ID: APP-2025-001</small>
          </div>

          <button className="btn btn-link text-dark fs-4" onClick={onHide}>
            ×
          </button>
        </div>

        {/* DETAILS */}
        <Row className="mb-4">
          <Col md={6}>
            <div className="label">Category</div>
            <div className="value">KYC Verification</div>
          </Col>

          <Col md={6}>
            <div className="label">Type</div>
            <div className="value">Document Collection</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Subtype</div>
            <div className="value">Incorrect Spelling</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Target Date</div>
            <div className="value">Oct 20, 2025</div>
          </Col>
        </Row>

        <hr />

        {/* REMARKS */}
        <div className="section-title">Remarks from Admin</div>
        <p className="text-muted">
          The name present in the KYC document is incorrect.
        </p>

        <hr />

        {/* CORRECTED FIELD SECTION */}
        <div>
            <div className="d-flex justify-content-between">
                <div className="section-title mb-2">Corrected Field</div>
                <Col md={1} className="text-end">
                    <Button variant="light" className="add-btn">
                    <Plus size={20} />
                    </Button>
                </Col>
            </div>

            <div 
                // className="correction-box p-3 mt-2"
            >
            <Row className="align-items-center">
                <Col md={4}>
                <Form.Select className="correction-select">
                    <option>Name</option>
                    <option>Date of Birth</option>
                    <option>Address</option>
                </Form.Select>
                </Col>

                <Col md={7}>
                <Form.Control
                    type="text"
                    placeholder="Corrected field input"
                    className="correction-input"
                />
                </Col>
            </Row>
            </div>
        </div>

        <hr />

        {/* FOOTER DETAILS */}
        <Row className="mt-3 mb-4">
          <Col md={6}>
            <div className="label">Assigned To</div>
            <div className="value">Rahul Kumar</div>
          </Col>

          <Col md={6}>
            <div className="label">Created By</div>
            <div className="value">Sushmit</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Created At</div>
            <div className="value">Oct 17, 2025 10:30</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Updated At</div>
            <div className="value">Oct 17, 2025 10:30</div>
          </Col>
        </Row>

        {/* ACTION BUTTONS */}
        <div className="d-flex justify-content-between mt-4">
          <Button variant="danger" className="px-4 submit-btn">
            <IoClose /> Submit
          </Button>
          <Button variant="success" className="px-4 submit-btn">
            <IoCheckmark /> Submit
          </Button>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default FieldUpdateModal;
